import { render } from "./ExpiredMedicalCert.vue?vue&type=template&id=11f25dce"
import script from "./ExpiredMedicalCert.vue?vue&type=script&lang=js"
export * from "./ExpiredMedicalCert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__